import { useEffect, useState } from "react";
import PageLayout from "../common/PageLayout";
import { useNavigate, useParams } from "react-router-dom";
import {
  Alert,
  Box,
  CircularProgress,
  Divider,
  Grid,
} from "@mui/material";
import { TbListDetails } from "react-icons/tb";
import { AppReviewRepository } from "../repositories/AppReviewRepository";
import ReviewDetails from "./ReviewDetails";
import ReviewAttachedDocuments from "./ReviewAttachedDocuments";
import ReviewStatusesPanel from "./ReviewStatusesPanel";
import ReviewOtherDocuments from "./ReviewOtherDocuments";
import ReviewRequests from "./ReviewRequests";
import ReviewAssignmentPanel from "./ReviewAssignmentPanel";
import { ErrorMessageResolver } from "../common/ErrorMessageResolver";
import { useSelector } from "react-redux";

export const ReviewAssignmentView = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [appReview, setAppReview] = useState(null);
  const [error, setError] = useState(null);
  const auth = useSelector((state) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      getById();
    }
  }, [id]);

  const getById = () => {
    setLoading(true);
    AppReviewRepository.getById(id)
      .then((res) => {
        setLoading(false);
        setAppReview(res.data);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        setError(ErrorMessageResolver.resolve(err));
      });
  };

  const attachedDocuments = appReview?.appEntry?.attachments?.filter(
    (attachment) =>
      [
        "URBAN_PLANING_PROJECT_DWG",
        "URBAN_PLANING_PROJECT_PDF",
        "TRAFFIC_ENGINEERING_PROJECT_DWG",
        "TRAFFIC_ENGINEERING_PROJECT_PDF",
        "PROJECT_REVISION",
      ].includes(attachment.documentType),
  );

  const otherDocuments = appReview?.appEntry?.attachments?.filter(
    (attachment) =>
      ["PROOF_OF_PAYMENT", "POWER_OF_ATTORNEY"].includes(
        attachment.documentType,
      ),
  );

  return (
    <PageLayout
      title={appReview?.appEntry?.trackingNumber}
      Icon={TbListDetails}
      subtitle={"Идентификатор"}
    >
      {loading && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="300px"
        >
          <CircularProgress />
        </Box>
      )}

      {error && !loading && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="100px"
        >
          <Alert severity="error" variant="filled">
            {error}
          </Alert>
          <Divider />
        </Box>
      )}

      {!error && !loading && appReview && (
        <Grid container spacing={2}>
          <ReviewStatusesPanel appReview={appReview} />
          {appReview?.appEntry?.status === "INSTITUTIONS_REVIEW" &&
            (auth?.userData?.roles?.includes("ROLE_MVR_SIGNER") ||
              auth?.userData?.roles?.includes("ROLE_JPDP_SIGNER") ||
              auth?.userData?.roles?.includes("ROLE_SUPER_ADMIN")) && (
              <ReviewAssignmentPanel
                appReview={appReview}
                onAssigned={getById}
                onBack={() => navigate("/reviews/assignment")}
              />
            )}
          <Grid item xs={12} md={6} style={{ marginTop: "10px" }}>
            <Grid container spacing={0}>
              <ReviewDetails appReview={appReview} appEntry={""} />
              {(auth?.userData?.roles?.includes("ROLE_JPDP_RECEIVER") ||
                auth?.userData?.roles?.includes("ROLE_JPDP_REVIEWER") ||
                auth?.userData?.roles?.includes("ROLE_MVR_REVIEWER") ||
                auth?.userData?.roles?.includes("ROLE_MVR_SIGNER") ||
                auth?.userData?.roles?.includes("ROLE_JPDP_SIGNER") ||
                auth?.userData?.roles?.includes("ROLE_JPDP_ADMINISTRATOR") ||
                auth?.userData?.roles?.includes("ROLE_MVR_ADMINISTRATOR")) && (
                <>
                  <ReviewAttachedDocuments
                    appReview={appReview}
                    attachedDocuments={attachedDocuments}
                  />
                </>
              )}
            </Grid>
          </Grid>
          <Grid item xs={12} md={6}>
            <Grid container spacing={0}>
              <ReviewOtherDocuments
                otherDocuments={otherDocuments}
                appReview={appReview}
              />
              <ReviewRequests appReview={appReview} />
            </Grid>
          </Grid>
        </Grid>
      )}
    </PageLayout>
  );
};
